// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleFilledSvg from "@fishx/icons-svg/es/asn/PoundCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleFilledSvg
  }));
};

PoundCircleFilled.displayName = 'PoundCircleFilled';
export default React.forwardRef(PoundCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PoundCircleFilled.js
// module id = 3834
// module chunks = 0